/* DentistryGlobal – play product videos inside the PDP gallery.
   The custom gallery only renders images; this turns video thumbnails into
   real playable videos in the main media area. */
(function () {
  function init() {
    var gallery = document.querySelector('.hp-pdp-gallery');
    var main = gallery && gallery.querySelector('.hp-pdp-main-img');
    var thumbs = gallery ? gallery.querySelectorAll('.hp-pdp-thumbs .dg-pdp-thumb') : [];
    if (!main || !thumbs.length) return;

    var path = window.location.pathname.replace(/\/$/, '');
    if (path.indexOf('/products/') === -1) return;

    fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product || !product.media) return;
        var hasVideo = false;

        product.media.forEach(function (m, i) {
          if (m.media_type !== 'video' || !thumbs[i] || !m.sources) return;
          var mp4 = m.sources.filter(function (s) { return s.format === 'mp4'; });
          if (!mp4.length) return;
          var pick = mp4.filter(function (s) { return s.height === 720; })[0] || mp4[mp4.length - 1];
          var btn = thumbs[i];
          btn.setAttribute('data-video', pick.url);
          btn.removeAttribute('onclick');
          btn.setAttribute('aria-label', 'Shiko videon');
          var badge = document.createElement('span');
          badge.className = 'dg-thumb-play';
          badge.setAttribute('aria-hidden', 'true');
          badge.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="rgba(0,0,0,.55)"/><path d="M10 8l6 4-6 4z" fill="#fff"/></svg>';
          btn.appendChild(badge);
          hasVideo = true;
        });
        if (!hasVideo) return;

        var style = document.createElement('style');
        style.textContent =
          '.hp-pdp-thumb{position:relative}' +
          '.dg-thumb-play{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;pointer-events:none}' +
          '.hp-pdp-main-img video.dg-pdp-main-video{width:100%;height:100%;object-fit:contain;background:#000;cursor:default}' +
          '.hp-pdp-main-img video.dg-pdp-main-video[hidden]{display:none}';
        document.head.appendChild(style);

        var video = document.createElement('video');
        video.className = 'dg-pdp-main-video';
        video.hidden = true;
        video.muted = true;
        video.loop = true;
        video.controls = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('preload', 'none');
        video.addEventListener('click', function (e) { e.stopPropagation(); });
        main.appendChild(video);

        var img = document.getElementById('dg-pdp-main-img-tag');
        var hint = main.querySelector('.hp-pdp-zoom-hint');

        Array.prototype.forEach.call(thumbs, function (btn) {
          btn.addEventListener('click', function () {
            Array.prototype.forEach.call(thumbs, function (b) { b.classList.remove('active'); });
            btn.classList.add('active');
            var src = btn.getAttribute('data-video');
            if (src) {
              if (video.getAttribute('src') !== src) video.setAttribute('src', src);
              video.hidden = false;
              if (img) img.style.display = 'none';
              if (hint) hint.style.display = 'none';
              video.muted = true;
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              video.pause();
              video.hidden = true;
              if (img) img.style.display = '';
              if (hint) hint.style.display = '';
            }
          });
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
